import React, { useState, useEffect, useRef } from "react";
import editIcon from "../assets/edit-icon.jpg"; // Make sure path is correct
import { Link, useNavigate } from "react-router-dom";
import "../styles/Settings.css"; // Make sure path is correct
import "../styles/Quiz.css";
import defaultAvatar from "../assets/OIP.jpg"; // Make sure path is correct
import Quiz from "../Component/QuizNoRoute"
import QuizNoRoute from "../Component/QuizNoRoute";
const Settings = () => {
const API_URL = process.env.REACT_APP_API_PATH;
  const navigate = useNavigate();
  const userId = sessionStorage.getItem("user");
  const userToken = sessionStorage.getItem("token");
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const user = sessionStorage.getItem("user");
    if (!token || !user) {
      
      navigate("/login");
    }
  }, [navigate]);
  const fileInputRef = useRef(null);

  // State for form fields
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); // Start empty, use placeholder for display
  const [picture, setPicture] = useState(defaultAvatar);

  // UI State
  const [isHovering, setIsHovering] = useState(false);
  const [isEditing, setIsEditing] = useState({ username: false, email: false, password: false });
  const [isLoading, setIsLoading] = useState(true); // Loading initial data
  const [isSubmitting, setIsSubmitting] = useState(false); // Submitting changes
  const [isUploading, setIsUploading] = useState(false); // Uploading picture
  const [error, setError] = useState(null);
  
const [topic, setTopic] = useState([]);

 
  const isLoggedIn = Boolean(userToken && userId);
const [modalOpen, setModalOpen] = useState(false);
 

  // Get user info from sessionStorage once
 

  // Effect to check login status
  useEffect(() => {
   
    if (!userToken || !userId) {
     
      navigate("/login");
    }
   
  }, [navigate, userToken, userId]);

  // Effect to load initial user data
  useEffect(() => {
    if (!userId || !userToken || !API_URL) {
        setIsLoading(false); // Stop loading if required info is missing
        if (!API_URL) console.error("API URL not configured.");
        setError("Could not load user data. Missing required information or configuration.");
        return;
    }
   

    setIsLoading(true);
    setError(null);

    fetch(`${API_URL}/users/${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw new Error(err.message || `Failed to fetch user data (${response.status})`); })
            .catch(() => { throw new Error(`Failed to fetch user data (${response.status})`); });
        }
        return response.json();
      })
      .then(profile => {
        setEmail(profile.email || "");
        // Store initial values in sessionStorage if needed elsewhere immediately
        sessionStorage.setItem("newEmail", profile.email || "");

        if (profile.attributes) {
          
          setUsername(profile.attributes.username || "");
          setPicture(profile.attributes.picture || defaultAvatar);
           sessionStorage.setItem("newUsername", profile.attributes.username || "");
           sessionStorage.setItem("profileImage", profile.attributes.picture || defaultAvatar);
  
          setTopic(profile.attributes.filter || [] );
      
  
        } else {
             setUsername("");
             setPicture(defaultAvatar);
             sessionStorage.setItem("newUsername", "");
             sessionStorage.setItem("profileImage", defaultAvatar);
        }
        // Don't fetch/set password
        setPassword(""); // Keep password field empty initially
      })
      .catch(err => {
        console.error("Error loading settings data:", err);
        setError(err.message || "Failed to load settings.");
      })
      .finally(() => {
        setIsLoading(false);
      });

  }, [userId, userToken, API_URL]); // Dependencies for fetching initial data


  const handleInputChange = (field, value) => {
    if (field === "username") setUsername(value);
    if (field === "email") setEmail(value);
    if (field === "password") setPassword(value); // Update password state
  };

  // No need to save to session storage on blur, save only on successful submit
   const handleBlur = (field) => {
     setIsEditing({ ...isEditing, [field]: false });
     // Removed sessionStorage updates from here
   };

  const handleAvatarClick = () => {
    if (!isUploading) { // Prevent clicking while upload is in progress
       fileInputRef.current.click();
    }
  };

  const uploadPicture = async (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (!file || !userId || !userToken || !API_URL) return;

    setIsUploading(true); // Indicate upload start
    setError(null);

    const formData = new FormData();
    formData.append("uploaderID", userId);
    // Attributes might not be needed for file upload itself, check API spec
    formData.append("attributes", JSON.stringify({ context: "profilePicture" })); // Example context
    formData.append("file", file);

    try {
       // 1. Upload the file
        const uploadResponse = await fetch(`${API_URL}/file-uploads`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${userToken}`,
              // 'Content-Type' is set automatically by browser for FormData
            },
            body: formData,
        });

        if (!uploadResponse.ok) {
            const errData = await uploadResponse.json().catch(() => ({}));
            throw new Error(errData.message || `Error uploading file (${uploadResponse.status})`);
        }

        const uploadResult = await uploadResponse.json();
        // --- IMPORTANT: Construct the FULL URL ---
        // Adjust base URL as needed - this assumes your API returns a relative path
        const pictureURL = (uploadResult.path.startsWith('http') ? uploadResult.path : "https://webdev.cse.buffalo.edu" + uploadResult.path);

        // 2. Fetch current user attributes before patching
        const profileResponse = await fetch(`${API_URL}/users/${userId}`, {
            method: "GET",
            headers: { Authorization: `Bearer ${userToken}` },
        });
        if (!profileResponse.ok) {
            throw new Error("Could not fetch current profile data before updating picture.");
        }
        const currentProfile = await profileResponse.json();
        const currentAttributes = currentProfile.attributes || {};

        // 3. Patch the user profile with the new picture URL, preserving other attributes
        const patchResponse = await fetch(`${API_URL}/users/${userId}`, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
            body: JSON.stringify({
              attributes: {
                  ...currentAttributes, // Spread existing attributes
                  picture: pictureURL, // Update only the picture
              },
            }),
        });

         if (!patchResponse.ok) {
            const errData = await patchResponse.json().catch(() => ({}));
            throw new Error(errData.message || `Failed to update profile picture (${patchResponse.status})`);
        }

        // 4. Update local state and sessionStorage on success
        setPicture(pictureURL);
        sessionStorage.setItem("profileImage", pictureURL);
         alert("Profile picture updated successfully!");


    } catch (err) {
        console.error("Error in picture upload process:", err);
        setError(err.message || "An error occurred during picture upload.");
       
    } finally {
        setIsUploading(false); // Indicate upload finish
        // Reset file input value so the same file can be selected again if needed
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }
  };


  // --- MODIFIED handleSubmit ---
  const handleSubmit = async () => {
    if (!userId || !userToken || !API_URL) {
       setError("Cannot submit. Missing user information or configuration.");
       return;
    }
    setIsSubmitting(true);
    setError(null);

    try {
        // 1. Fetch the current user profile data first
        const responseGet = await fetch(`${API_URL}/users/${userId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${userToken}`
            }
        });

        if (!responseGet.ok) {
            throw new Error('Failed to fetch current user data before updating.');
        }

        const currentUserData = await responseGet.json();
        const currentAttributes = currentUserData.attributes || {}; // Get existing attributes

        // 2. Prepare the payload for PATCH
        // Only include fields that have actually changed or are intended to be set
        const payload = {
            attributes: {
                ...currentAttributes, // Start with all current attributes
                username: username, // Overwrite username with the state value
                picture: picture // Overwrite picture with the state value (already updated if changed)
            }
        };

        // Only include email if it's different from the fetched one (optional, but good practice)
        if (email !== currentUserData.email) {
            payload.email = email;
        }

        // --- IMPORTANT: Only include password if it's not empty ---
        if (password && password.trim() !== "") {
             // Add validation here if needed (e.g., password complexity)
            payload.password = password;
        } else {
             // Explicitly DO NOT send the password field if it's empty in the form
             // The backend should ignore the missing password field on PATCH
        }


        // 3. Send the PATCH request with the merged data
        const responsePatch = await fetch(`${API_URL}/users/${userId}`, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
            body: JSON.stringify(payload), // Send the carefully constructed payload
        });

        if (!responsePatch.ok) {
            const errorData = await responsePatch.json().catch(() => ({}));
            throw new Error(errorData.message || "Failed to update profile. Please try again.");
        }

        // 4. Update sessionStorage ONLY on successful PATCH
        sessionStorage.setItem("newUsername", username);
        sessionStorage.setItem("newEmail", email);
        // DO NOT store the actual password in sessionStorage
        // sessionStorage.setItem("newPassword", password); // Avoid this!
        sessionStorage.setItem("profileImage", picture);

        // Optionally clear the password field after successful submission
        setPassword("");

        alert(`Profile updated successfully!`);

    } catch (err) {
      console.error("Error updating profile:", err);
      setError(err.message);
      
    } finally {
      setIsSubmitting(false);
    }
  };

  // --- Render Logic ---
  if (isLoading) {
      return <div className="settings-container"><p>Loading settings...</p></div>;
  }

 

  function Modal({ onClose }) {
    return (
      <div className="edit-pop" id="quiz-modal">
        <div>
          <h3 className="Quiz-title">Edit Topics</h3>
         <QuizNoRoute></QuizNoRoute>
        
 
          <button className="close-edit" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="settings-container">
      <div className="profile-picture-container">
        {/* Show spinner or different icon during upload */}
        <img
          src={isUploading ? editIcon : (isHovering ? editIcon : picture)} // Show edit icon during upload too
          alt="Profile"
          className={`profile-picture ${isHovering ? "hovered" : ""} ${isUploading ? "uploading" : ""}`} // Add uploading class
          onClick={handleAvatarClick}
          onMouseEnter={() => !isUploading && setIsHovering(true)} // Don't hover if uploading
          onMouseLeave={() => setIsHovering(false)}
        />
        {isUploading && <div className="upload-indicator">Uploading...</div>} {/* Simple indicator */}
        <input
          type="file"
          accept="image/*,.jpg,.jpeg,.png,.gif" // Be more specific with accept types
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={uploadPicture}
          disabled={isUploading} // Disable input during upload
        />
      </div>
  
      <div className="settings-list">
        {/* Email Field */}
        <div className="settings-item" onClick={() => !isEditing.email && setIsEditing({ ...isEditing, email: true })}>
          <span className="settings-label"><strong>Email</strong></span>
          {isEditing.email ? (
            <input
              className="settings-input" // Add class for styling
              type="email"
              value={email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              onBlur={() => handleBlur("email")}
              autoFocus
            />
          ) : (
            <span className="settings-value">{email || "Not set"}</span>
          )}
        </div>
  
        {/* Username Field */}
        <div className="settings-item" onClick={() => !isEditing.username && setIsEditing({ ...isEditing, username: true })}>
          <span className="settings-label"><strong>Username</strong></span>
          {isEditing.username ? (
            <input
              className="settings-input" // Add class for styling
              type="text"
              value={username}
              onChange={(e) => handleInputChange("username", e.target.value)}
              onBlur={() => handleBlur("username")}
              autoFocus
            />
          ) : (
            <span className="settings-value">{username || "Not set"}</span>
          )}
        </div>
  
        {/* Password Field */}
        <div className="settings-item" onClick={() => !isEditing.password && setIsEditing({ ...isEditing, password: true })}>
          <span className="settings-label"><strong>Password</strong></span>
          {isEditing.password ? (
            <input
              className="settings-input" // Add class for styling
              type="password"
              value={password} // Show the actual password being typed
              placeholder="Enter new password" // Placeholder for clarity
              onChange={(e) => handleInputChange("password", e.target.value)}
              onBlur={() => handleBlur("password")}
              autoFocus
            />
          ) : (
            // Show placeholder - never display actual password
            <span className="settings-value">********</span>
          )}
        </div>
      </div>
  
      <div className="submit-container">
        <button className="submit-button" onClick={handleSubmit} disabled={isSubmitting || isUploading}>
          {isSubmitting ? "Submitting..." : "Save Changes"}
        </button>
  
        <hr className="salign" />
        <div className="Quiz-title"><u>Edit Food Choices</u></div>
        <br />
  
        <div className="edit-quiz">
          {topic && topic.length > 0 ? (
            topic.map((item, index) => (
              <div key={index} className="result-cont">
                {item}
              </div>
            ))
          ) : (
            <p>No food choices set.</p>
          )}
          <br />
          <button className="qedit-buttton" onClick={() => setModalOpen(true)}>Edit</button>
          {modalOpen && <Modal onClose={() => setModalOpen(false)} />}
        </div>
      </div>
  
      <br />
      <hr className="salign" />
      <div className="BlockedUsers">
        <Link to="/blockedUsers">
          <button className="submit-button">
            See List of Blocked Users
          </button>
        </Link>
      </div>
      <Link to="/delete-account" className="help-button">Delete your account</Link>
    </div>
  );
  
};

export default Settings;